import RubricsPage from "./RubricsPage";

export { RubricsPage };
export default RubricsPage;
